import React, { useRef } from 'react';
import { connect } from 'react-redux';

import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { IconWrapper } from 'apps/auth/components/common/Panel/styles';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { Text } from 'apps/auth/components/common/Text/Text';
import SecurityRightMenu from 'apps/auth/components/profile/security/SecurityRightMenu';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_PROFILE_SETTINGS, AUTH_SETTINGS } from 'apps/auth/constants/UrlConstants';

const SecurityPage = (props) => {
    const popupRef = useRef(null);
    return (
        <>
            <CommonPage backUrl={AUTH_PROFILE_SETTINGS} rightHeaderComponent={<SecurityRightMenu popupRef={popupRef} />} showChat={!props.isShowModal}>
                <HeaderPanel title={props.headerTitle} />
                <Panel type="reactLink" to={AUTH_SETTINGS} negativeMargin hasIcon isHoverable>
                    <IconWrapper>
                        <Icon name="shield" color="primary" />
                    </IconWrapper>
                    <Text>{props.securityTwoStepsTitle}</Text>
                </Panel>
            </CommonPage>
            <PopupNew ref={popupRef} />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        securityTwoStepsTitle: state.messages.pageMessages.securityTwoStepsTitle,
        headerTitle: state.messages.pageMessages.headerTitle,
        isShowModal: state.app.isShowModal,
    };
};

export default connect(mapStateToProps, null)(BasePage(SecurityPage));
